// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hover reveal: oculto por defecto, aparece con transición 200ms */
.download-button-wrapper {
  position: absolute;
  bottom: 12px;
  right: 12px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 200ms ease-in-out;
  z-index: 2;
}

.download-button-wrapper--visible,
.recording-card:hover .download-button-wrapper,
.recording-card:focus-within .download-button-wrapper {
  opacity: 1;
  pointer-events: auto;
}

/* Zona de click generosa: mínimo 44x44px (estándar táctil) */
.download-button {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
  padding: 0;
  border: none;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.15s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.download-button:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.85);
  transform: scale(1.05);
}

.download-button:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
}

.download-button:focus-visible {
  box-shadow: 0 0 0 2px #4a9eff;
}

.download-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.download-button:active:not(:disabled) {
  transform: scale(0.98);
}
`, "",{"version":3,"sources":["webpack://./src/components/DownloadButton.css"],"names":[],"mappings":"AAAA,mEAAmE;AACnE;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,qCAAqC;EACrC,UAAU;AACZ;;AAEA;;;EAGE,UAAU;EACV,oBAAoB;AACtB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,uDAAuD;EACvD,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["/* Hover reveal: oculto por defecto, aparece con transición 200ms */\n.download-button-wrapper {\n  position: absolute;\n  bottom: 12px;\n  right: 12px;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 200ms ease-in-out;\n  z-index: 2;\n}\n\n.download-button-wrapper--visible,\n.recording-card:hover .download-button-wrapper,\n.recording-card:focus-within .download-button-wrapper {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n/* Zona de click generosa: mínimo 44x44px (estándar táctil) */\n.download-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 44px;\n  min-height: 44px;\n  padding: 0;\n  border: none;\n  border-radius: 12px;\n  background: rgba(0, 0, 0, 0.65);\n  color: #fff;\n  cursor: pointer;\n  transition: background 0.15s ease, transform 0.15s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.download-button:hover:not(:disabled) {\n  background: rgba(0, 0, 0, 0.85);\n  transform: scale(1.05);\n}\n\n.download-button:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);\n}\n\n.download-button:focus-visible {\n  box-shadow: 0 0 0 2px #4a9eff;\n}\n\n.download-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.download-button:active:not(:disabled) {\n  transform: scale(0.98);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
